
export enum App {
    Gifts = 1,
    ConflictOfInterest = 2,
    OrgConflictOfInterest = 3
}